// Keep updated with SubGroupUserMembership in cryptoview/models/group.py
import { SortingOrder } from "types";
import { SortOrder } from "antd/es/table/interface";
import {
  CHANGE_FULL_NAME_FEATURE_FLAG,
  IS_MOBILE_WEBVIEW_WINDOW_KEY,
} from "@shared/common/constants";
import { BotConfigurationType } from "@shared/types";

export const USER_MEMBERSHIP_ACTIVE_STATUS = "ACTIVE";
export const USER_MEMBERSHIP_USER_LEFT_STATUS = "USER_LEFT";
export const USER_MEMBERSHIP_ADMIN_KICKED_STATUS = "ADMIN_KICKED";
export const USER_MEMBERSHIP_BOT_KICKED_STATUS = "BOT_KICKED";
export const USER_MEMBERSHIP_UNAUTHORIZED_STATUS = "UNAUTHORIZED";
export const USER_MEMBERSHIP_INACTIVE_UNCLASSIFIED_STATUS =
  "INACTIVE_UNCLASSIFIED";
export const USER_MEMBERSHIP_UNAUTHORIZED_USER_LEFT_STATUS =
  "UNAUTHORIZED_USER_LEFT";
export const USER_MEMBERSHIP_AUTHORIZED_PENDING_STATUS = "AUTHORIZED_PENDING";
export const USER_MEMBERSHIP_EXPIRED_KICKED_STATUS = "EXPIRED_KICKED";
export const USER_MEMBERSHIP_EXPIRED_IN_GROUP_STATUS = "EXPIRED_IN_GROUP";

export const NOT_IN_GROUP_STATUSES = [
  USER_MEMBERSHIP_USER_LEFT_STATUS,
  USER_MEMBERSHIP_ADMIN_KICKED_STATUS,
  USER_MEMBERSHIP_BOT_KICKED_STATUS,
  USER_MEMBERSHIP_INACTIVE_UNCLASSIFIED_STATUS,
  USER_MEMBERSHIP_UNAUTHORIZED_USER_LEFT_STATUS,
  USER_MEMBERSHIP_AUTHORIZED_PENDING_STATUS,
  USER_MEMBERSHIP_EXPIRED_KICKED_STATUS,
];

export const INACTIVE_GROUP_STATUSES = [
  USER_MEMBERSHIP_INACTIVE_UNCLASSIFIED_STATUS,
  USER_MEMBERSHIP_USER_LEFT_STATUS,
  USER_MEMBERSHIP_UNAUTHORIZED_USER_LEFT_STATUS,
];

export const PENDING_GROUP_STATUSES = [
  USER_MEMBERSHIP_AUTHORIZED_PENDING_STATUS,
];

export const KICKED_GROUP_STATUSES = [
  USER_MEMBERSHIP_ADMIN_KICKED_STATUS,
  USER_MEMBERSHIP_BOT_KICKED_STATUS,
  USER_MEMBERSHIP_EXPIRED_KICKED_STATUS,
];

export const SUB_GROUP_INVITATION_ACTIVE_STATUS = "ACTIVE";
export const SUB_GROUP_INVITATION_INACTIVE_STATUS = "INACTIVE";

export const SUB_GROUP_CONFIGURATION_KICK_EXPIRED_USERS = "kick_expired_users";
export const SUB_GROUP_CONFIGURATION_KICK_UNAUTHORIZED_USERS =
  "kick_unauthorized_users";

// Create order constants
export const ENTRY_ORDER = "entry";
export const TAKE_PROFIT_ORDER = "take_profit";
export const MARKET_ORDER_TYPE = "market";
export const STOP_LIMIT_ORDER_TYPE = "stop_limit";
export const STOP_MARKET_ORDER_TYPE = "stop_market";
export const LIMIT_ORDER_TYPE = "limit";

export const ORDER_TYPE_TO_DISPLAY = {
  [MARKET_ORDER_TYPE]: "Market",
  [LIMIT_ORDER_TYPE]: "Limit",
  [STOP_LIMIT_ORDER_TYPE]: "Stop limit",
  [STOP_MARKET_ORDER_TYPE]: "Stop market",
};

export const LOGIN_PATH = "/login";
export const OAUTH_LOGIN_PATH = "/oauth_login";
export const DISCORD_FOLLOW_SIGNAL_PATH = "/signal_details";
export const BASE_REGISTER_PATH = "/register";
export const REGISTER_PATH = BASE_REGISTER_PATH + "/:referralCode?";
export const RESET_PASSWORD_PATH = "/reset-password";
export const REGISTER_VERIFY_EMAIL_PATH = BASE_REGISTER_PATH + "/verify-email";
export const AUTH_PATHS = [
  LOGIN_PATH,
  RESET_PASSWORD_PATH,
  REGISTER_PATH,
  REGISTER_VERIFY_EMAIL_PATH,
];

export const ONBOARDING_VERIFY_EMAIL_PATH =
  BASE_REGISTER_PATH + "/confirm-email";
export const ONBOARDING_CONFIRM_SOCIAL_CODE_PATH =
  BASE_REGISTER_PATH + "/confirm-social";
export const ONBOARDING_SELECT_EXCHANGE_PATH =
  BASE_REGISTER_PATH + "/select-exchange";
export const ONBOARDING_CONNECT_EXCHANGE_PATH =
  BASE_REGISTER_PATH + "/connect-exchange";
export const ONBOARDING_TRADING_METHOD_PATH =
  BASE_REGISTER_PATH + "/trading-method";
export const ONBOARDING_FOLLOW_SIGNALS_GROUP_PATH =
  BASE_REGISTER_PATH + "/follow-signals-group";
export const ONBOARDING_CONNECT_EXTERNAL_ACCOUNT_PATH =
  BASE_REGISTER_PATH + "/connect-external-account";
export const ONBOARDING_COPY_DCA_BOT_PATH =
  BASE_REGISTER_PATH + "/copy-dca-bot";
export const ONBOARDING_SIGNALS_GROUP_OVERVIEW_PATH =
  BASE_REGISTER_PATH + "/signals-group-overview";
export const ONBOARDING_DCA_BOT_OVERVIEW_PATH =
  BASE_REGISTER_PATH + "/dca-bot-overview";

export const ONBOARDING_PATHS = [
  ONBOARDING_VERIFY_EMAIL_PATH,
  ONBOARDING_CONFIRM_SOCIAL_CODE_PATH,
  ONBOARDING_SELECT_EXCHANGE_PATH,
  ONBOARDING_CONNECT_EXCHANGE_PATH,
  ONBOARDING_TRADING_METHOD_PATH,
  ONBOARDING_FOLLOW_SIGNALS_GROUP_PATH,
  ONBOARDING_CONNECT_EXTERNAL_ACCOUNT_PATH,
  ONBOARDING_COPY_DCA_BOT_PATH,
  ONBOARDING_SIGNALS_GROUP_OVERVIEW_PATH,
  ONBOARDING_DCA_BOT_OVERVIEW_PATH,
];

export const QUICK_ONBOARDING_SUFFIX = "/quick-onboarding";
export const QUICK_ONBOARDING_PATH = "*" + QUICK_ONBOARDING_SUFFIX;

export const CONNECT_TELEGRAM_PATH = "/connect-telegram";
export const VALIDATE_TELEGRAM_PATH = "/validate-connect-telegram";

export const ADMIN_PATH = "/admin";
export const BASE_GROUP_MANAGEMENT_PATH = ADMIN_PATH + "/group-management";
export const GROUP_MANAGEMENT_PATH = BASE_GROUP_MANAGEMENT_PATH + "/:tab?";
export const ADMIN_SIGNALS_PATH = ADMIN_PATH + "/signals";
export const ADMIN_TRADING_CONFIGURATION_PATH =
  ADMIN_PATH + "/trading-configuration";

export const PORTFOLIO_PATH = "/portfolio";
export const PORTFOLIO_ASSETS_PATH = PORTFOLIO_PATH + "/assets";
export const PORTFOLIO_ACCOUNTS_PATH = PORTFOLIO_PATH + "/accounts";
export const BASE_TRADES_PATH = "/trades";
export const TRADES_PATH = BASE_TRADES_PATH + "/:tab?";
export const OPEN_TRADES_PATH = BASE_TRADES_PATH + "/open";
export const CLOSED_TRADES_PATH = BASE_TRADES_PATH + "/closed";
export const CREATE_TRADE_PATH = "/trading-terminal";
export const WATCHLIST_PATH = "/watchlist";
export const DASHBOARD_PATH = "/dashboard";
export const BOTS_PATH = "/bots";
export const BASE_BOTS_PATH =
  BOTS_PATH + "/:botType(tradingview|dca|signals|grid)";
export const BASE_BOTS_BACKTESTING_PATH = BASE_BOTS_PATH + "/backtesting";
export const BASE_BOTS_WITH_ACTION_PATH =
  BASE_BOTS_PATH + "/:action(edit|duplicate|create|bulk_create)?/:botId(\\d+)?";
export const BASE_BOT_FORM_PATH =
  BASE_BOTS_PATH + "/:action(edit|duplicate|create|bulk_create)/:botId(\\d+)?";
export const ADMIN_TRADING_CONFIGURATION_FORM_PATH =
  ADMIN_TRADING_CONFIGURATION_PATH +
  `/:configurationType(${BotConfigurationType.LEVERAGE}|${BotConfigurationType.SPOT})`;
export const TRADING_VIEW_BOT_PATH = BOTS_PATH + "/tradingview";
export const SIGNALS_BOT_PATH = BOTS_PATH + "/signals";
export const GRID_BOT_PATH = BOTS_PATH + "/grid";
export const BASE_DCA_BOTS_PATH = BOTS_PATH + "/dca";
export const BASE_PUBLIC_BOT_PATH = BASE_BOTS_PATH + "/public/:botUUID";
export const DCA_PUBLIC_BOTS_PATH = BASE_DCA_BOTS_PATH + "/public-bots";
export const BASE_PUBLIC_EDIT_BOT_PATH =
  BASE_BOTS_PATH + "/public/edit/:botUUID";
export const AFFILIATION_PATH = "/affiliation/:tab?";

export const UNIVERSAL_LINKS_PATHS = ["/cornix_registration", "/cornix_login"];
export const USER_SIGNALS_PATH = "/signals";
export const MARKETPLACE_PATH = "/marketplace";
export const GROUP_CONFIGURATION_SUFFIX =
  "/group-configuration-details/:subGroupId(\\d+)";
export const GROUP_CONFIGURATION_PATH = "*" + GROUP_CONFIGURATION_SUFFIX;
export const MARKETPLACE_GROUP_SUFFIX =
  "/group-details/:subGroupId(\\d+)/:tab?";
export const MARKETPLACE_GROUP_PATH = "*" + MARKETPLACE_GROUP_SUFFIX;
export const CREATE_ACCOUNT_PATH = PORTFOLIO_ACCOUNTS_PATH + "/create-account";

export const SETTINGS_PATH = "/settings";
export const SECURITY_SETTINGS_PATH = SETTINGS_PATH + "/security";
export const NOTIFICATIONS_SETTINGS_PATH =
  SETTINGS_PATH + "/notifications-settings";
export const CHANGE_PASSWORD_SETTINGS_PATH =
  SECURITY_SETTINGS_PATH + "/change-pass";
export const CHANGE_NAME_SETTINGS_PATH =
  SECURITY_SETTINGS_PATH + "/change-name";

export const BASE_BILLING_SETTINGS_PATH = SETTINGS_PATH + "/billing";
export const BILLING_SETTINGS_PATH = SETTINGS_PATH + "/billing/:tab?";
export const BASE_PURCHASE_SUBSCRIPTION_SETTINGS_PATH =
  BASE_BILLING_SETTINGS_PATH + "/purchase";
export const PURCHASE_SUBSCRIPTION_SETTINGS_PATH =
  BASE_PURCHASE_SUBSCRIPTION_SETTINGS_PATH + "/:subGroupId(\\d+)?";
export const UPGRADE_SUBSCRIPTION_SETTINGS_PATH =
  BASE_BILLING_SETTINGS_PATH + "/upgrade";
export const PURCHASE_API_SLOTS_SETTINGS_PATH =
  BASE_BILLING_SETTINGS_PATH + "/purchase-api-slots";
export const BASE_FAILED_AGREEMENT_PATH = "/failed-agreement";
export const BASE_CANCELLED_AGREEMENT_PATH = "/cancelled-agreement";
export const BASE_PROCESSED_AGREEMENT_PATH = "/processed-agreement";
export const BASE_PAID_AGREEMENT_PATH = "/paid-agreement";
export const PROCESSED_AGREEMENT_SETTINGS_PATH =
  BASE_BILLING_SETTINGS_PATH + BASE_PROCESSED_AGREEMENT_PATH;
export const PAID_AGREEMENT_SETTINGS_PATH =
  BASE_BILLING_SETTINGS_PATH + BASE_PAID_AGREEMENT_PATH;
export const FAILED_AGREEMENT_SETTINGS_PATH =
  BASE_BILLING_SETTINGS_PATH + BASE_FAILED_AGREEMENT_PATH;
export const CANCELLED_AGREEMENT_SETTINGS_PATH =
  BASE_BILLING_SETTINGS_PATH + BASE_CANCELLED_AGREEMENT_PATH;
export const CONFIGURATION_TWO_FA_PATH =
  SECURITY_SETTINGS_PATH + "/two-factor-auth";
export const CONFIGURATION_DISABLE_TWO_FA_PATH =
  SECURITY_SETTINGS_PATH + "/disable-two-factor-auth";
export const COIN_EXTRA_DETAILS_SUFFIX = "/coin-details/:coin/:tab?";
export const COIN_EXTRA_DETAILS_PATH = "*" + COIN_EXTRA_DETAILS_SUFFIX;
export const ACCOUNT_EXTRA_DETAILS_SUFFIX =
  "/account-details/:accountId(\\d+)/:tab?";
export const ACCOUNT_EXTRA_DETAILS_PATH = "*" + ACCOUNT_EXTRA_DETAILS_SUFFIX;
export const TRADE_EXTRA_DETAILS_SUFFIX =
  "/trade-details/:tradeId(\\d+)/:tab?/:edit?";
export const BOT_EXTRA_DETAILS_SUFFIX = "/bot-details/:botId(\\d+)/:tab?";
export const BOT_EXTRA_DETAILS_PATH = "*" + BOT_EXTRA_DETAILS_SUFFIX;
export const TRADE_EXTRA_DETAILS_PATH = "*" + TRADE_EXTRA_DETAILS_SUFFIX;
export const BACKTESTING_EXTRA_DETAILS_SUFFIX =
  "/backtesting-details/:botId(\\d+)/:tab?";
export const BACKTESTING_EXTRA_DETAILS_PATH =
  "*" + BACKTESTING_EXTRA_DETAILS_SUFFIX;
export const SIGNAL_EXTRA_DETAILS_SUFFIX =
  "/signal-details/:signalId(\\d+)/:tab/:edit?";
export const SIGNAL_EXTRA_DETAILS_PATH = "*" + SIGNAL_EXTRA_DETAILS_SUFFIX;
export const MY_GROUPS_PATH = "/my-groups";
export const EXTERNAL_INVITE_PATH = "/external-invite";

export const TRADE_EXTRA_DETAILS_TABS = Object.freeze({
  GENERAL: "General",
  TIMELINE: "Timeline",
  ORDERS: "Orders",
  GRIDS: "Grids",
  CONFIGURATION: "Configuration",
});
export const COIN_EXTRA_DETAILS_TABS = Object.freeze({
  GENERAL: "General",
  TRADES: "Trades",
  ACCOUNTS: "Accounts",
});
export const ACCOUNT_EXTRA_DETAILS_TABS = Object.freeze({
  GENERAL: "General",
  TRADES: "Trades",
  COINS: "Coins",
});
export const GROUP_MANAGEMENT_TABS = Object.freeze({
  USERS: "Users",
  INVITATIONS: "Invitations",
  CONFIGURATION: "Configuration",
});

export const TIME_RANGE_START = "start";
export const TIME_RANGE_1_HOUR = "1h";
export const TIME_RANGE_6_HOURS = "6h";
export const TIME_RANGE_12_HOURS = "12h";
export const TIME_RANGE_1_DAY = "1d";
export const TIME_RANGE_3_DAYS = "3d";
export const TIME_RANGE_1_WEEK = "1w";
export const TIME_RANGE_1_MONTHS = "1m";
export const TIME_RANGE_3_MONTHS = "3m";
export const TIME_RANGE_1_YEAR = "1y";
export const TIME_RANGES = [
  TIME_RANGE_START,
  TIME_RANGE_1_HOUR,
  TIME_RANGE_6_HOURS,
  TIME_RANGE_12_HOURS,
  TIME_RANGE_1_DAY,
  TIME_RANGE_3_DAYS,
  TIME_RANGE_1_WEEK,
  TIME_RANGE_1_MONTHS,
  TIME_RANGE_3_MONTHS,
  TIME_RANGE_1_YEAR,
];

export const DISPLAY_CURRENCIES = {
  BTC: "BTC",
  USD: "USD",
} as const;

export const AFFILIATION_FEATURE_FLAG = "affiliation";
export const CHANGE_LEVERAGE_FEATURE_FLAG = "change_leverage";
export const MARKETPLACE_PAYMENTS_FEATURE_FLAG = "marketplace_payments";
export const MEMBERS_WHITELIST_IPS_FEATURE_FLAG = "members_whitelist_ips";
export const BULK_CREATE_BOTS_FEATURE_FLAG = "bulk_create_bots";
export const CREATE_ACCOUNT_INVITE_FEATURE_FLAG = "create_account_invite";

// Feature flags
export const PATH_TO_FEATURE_FLAG: Record<string, string> = {
  [CHANGE_NAME_SETTINGS_PATH]: CHANGE_FULL_NAME_FEATURE_FLAG,
};

// Breakpoints
export const MOBILE_FILTERS = "1200px";
export const COLLAPSED_DESKTOP_MENU = "1400px";
export const MOBILE_SEARCH = "600px";
export const VERY_SMALL_MOBILE = "365px";
export const SMALL_MOBILE = "450px";
export const LARGE_MOBILE = "700px";
export const MOBILE_CREATE_TRADE = "900px";
export const MOBILE_MENU = "900px";
export const SMALL_SCREEN = "1100px";
export const HIDE_INTERCOM_LAUNCHER_BREAKPOINT = MOBILE_SEARCH;
export const TABLET = "800px";
export const LARGE_TABLET = "850px";
export const MOBILE_VIRTUAL_LIST = "750px";
export const MAX_DRAWER_EXTENSION_SCREEN = "1100px";
export const BOTTOM_NAVIGATOR = "450px";
export const MAX_BACKTEST_DRAWER_EXTENSION_SCREEN = "1450px";

export const PAGE_SPINNER_MARGIN_FROM_TOP = 100;

export const TELEGRAM_ANNOUNCEMENTS_LINK = "https://t.me/cornix_announcements";
export const FACEBOOK_LINK = "https://www.facebook.com/cornix.io";
export const INSTAGRAM_LINK =
  "https://www.instagram.com/cornix_io/?utm_medium=copy_link";
export const WEBSITE_LINK = "https://cornix.io/";
export const LINKEDIN_LINK = "https://www.linkedin.com/company/cornix-io";
export const YOUTUBE_LINK =
  "https://www.youtube.com/channel/UCzHyRmZfXrwXjL8an9QhSUw";

export const APPSTORE_DOWNLOAD_LINK =
  "https://apps.apple.com/il/app/cornix/id1490691026";
export const GOOGLE_PLAY_DOWNLOAD_LINK =
  "https://play.google.com/store/apps/details?id=com.cornix";
export const GENERIC_DOWNLOAD_LINK =
  "https://app.cornix.io/cornix_registration";

// External links
export const EXTERNAL_ACCOUNT_CONFIGURATION_PATH =
  "/account-configuration/:accountId(\\d+)/:tab?";

export const SORT_ORDER_MAPPING: Record<SortingOrder, SortOrder> = {
  [SortingOrder.ASCEND]: "ascend",
  [SortingOrder.DESCEND]: "descend",
} as const;

export const MAIN_CONTENT_ID = "mainContent";

export const NEXT_URL_QUERY_PARAM = "next-path";

export const INTERCOM_ICON_SIZE = 48;
export const INTERCOM_BOTTOM = 20;
export const INTERCOM_TOTAL_SIZE = INTERCOM_ICON_SIZE + INTERCOM_BOTTOM;
export const BOTTOM_NAVIGATOR_HEIGHT = 56;

export const SIDER_COLLAPSED_SIZE = 50;
export const EXTRA_DETAILS_DRAWER_SCROLL_ID = "innerContentWrapper";

export const RESTRICTED_COUNTRY_TO_CODE = {
  Iran: "IR",
  Lebanon: "LB",
  Syria: "SY",
  "North Korea": "KP",
  Palestine: "PS",
  Iraq: "IQ",
  Somalia: "SO",
  "South Sudan": "SS",
  Cuba: "CU",
};
export const IS_MOBILE_WEBVIEW = (window as any)[IS_MOBILE_WEBVIEW_WINDOW_KEY];
export const TELEGRAM_WEB_APP = (window as any)?.Telegram?.WebApp as any;
export const IS_TELEGRAM_WEB_APP = !!TELEGRAM_WEB_APP?.initData;

export const TABS_HEADER_HEIGHT = 60;
export const INIT_DATA_QUERY_PARAM = "initData";
export const QUICK_CONNECT_DATA_QUERY_PARAM = "quickConnectData";
export const LOCAL_STORAGE_TELEGRAM_QUICK_CONNECT_KEY =
  "telegram_quick_connect";
export const LOCAL_STORAGE_TELEGRAM_INIT_DATA_KEY = "telegram_init_data";
export const LOCAL_STORAGE_TG_LAST_WRITE_ACCESS_KEY =
  "telegram_last_write_request";
export const TG_START_QUERY_PARAM = "tgWebAppStartParam";

export const DEFAULT_PADDING = 16;
export const SMALL_MOBILE_PADDING = 12;
export const DEFAULT_CHART_TOOLTIP_MARGIN = 8;
export const CHART_CUSTOM_POSITION_KEY = "custom_chart_cursor_position";

export const TELEGRAM_DISCONNECT_CONFIRMED_PATH =
  "/telegram-disconnected-confirmed";
export const DISCORD_DISCONNECT_CONFIRMED_PATH =
  "/discord-disconnected-confirmed";

export const LOCAL_STORAGE_FAILED_PAYMENT_KEY = "is_failed_payment";

export const DRAWER_TRADES_TABLE_FULL_WIDTH = 900;
export const NOT_GROUP_MEMBER_MESSAGE =
  "You are not a member of the group you are trying to access.";

export const SCROLL_VIEW_REFETCH_Y_POSITION = 75;
export const SCROLL_VIEW_REFETCH_NEGATIVE_Y_POSITION = -35;
export const REFRESH_SPINNER_SIZE = 50;
export const REFRESH_SPINNER_INITIAL_Y = -(REFRESH_SPINNER_SIZE + 15);
export const REFRESH_SPINNER_LOADING_Y = 15;

export const ACTION_BUTTON_SIZE = 50;
export const ACTION_BUTTON_MARGIN = 16;
export const ACTION_BUTTON_WITH_MARGIN_HEIGHT =
  ACTION_BUTTON_SIZE + ACTION_BUTTON_MARGIN * 2;

export const CODE_SPLITTING_REFRESH_QUERY_PARAM = "is-refresh";

export const GENERAL_BACKEND_ERROR = "Internal error, please contact support";

export const SWIPE_DRAWER_SCROLL_AREA_WIDTH = 30;
